module.exports = __webpack_public_path__ + "img/balkongelaender.351eb686.webp";